
export function PostJsonTyped<T>(url: string, obj: any = null) {
    return PostJson(url, obj).then(x => x.json() as T);
}

export function PostJson(url: string, obj: any = null) {
    return fetch(url, {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        headers: {
            "Content-Type": "application/json"
        },
        body: obj == null ? null : JSON.stringify(obj)
    }).then((response) => {
        if (!response.ok) {
            throw new Error("HTTP Error " + response.status + " " + response.statusText);
        }
        return response;
    });
}

export function GetWithParam(url: string, param: any = null) {
    // Convert param to base64
    let paramStr = JSON.stringify(param);
    let paramBase64 = Buffer.from(paramStr).toString('base64');
    let fullUrl = `${url}/${paramBase64}`;
    return fetch(fullUrl, {
        method: "GET",
        mode: "cors",
        cache: "default",
    });
}

export function Get(url: string) {
    return fetch(url, {
        method: "GET",
        mode: "cors",
        cache: "default",
    });
}